import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-table-previewer',
  templateUrl: './table-previewer.component.html',
  styleUrls: ['./table-previewer.component.css'],
})
export class TablePreviewerComponent implements OnInit {
  @Input() tableData: any[];
  @Input() model: any[];
  @Input() isButtonDisabled: boolean = false;
  @Input() showProgress: boolean = false;
  @Input() progressPercent: number = 0.0;
  @Input() title: string = 'Preview';
  @Input() submitButtonText: string = 'Submit';
  @Input() cancelButtonText: string = 'Cancel';
  @Output() confirmedData: EventEmitter<any[]> = new EventEmitter();
  @Output() onCancel: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  valueAtPath(obj: any, path: any) {
    path = path || '';
    path = path.split('.');
    obj = obj || {};
    var val = obj;
    for (var key of path) {
      if (val[key] != undefined) {
        val = val[key];
      } else {
        val = undefined;
      }
      if (val == undefined || val == null || val == '') {
        break;
      }
    }
    return val;
  }

  async onSubmit() {
    this.confirmedData.emit(this.tableData);
  }

  cancel() {
    this.onCancel.emit(true);
  }

  updateDataObject(obj: any, event: any, path: any) {
    obj = this.assign(
      obj,
      path,
      event.target.value && !isNaN(event.target.value)
        ? parseFloat(event.target.value)
        : event.target.value,
    );
  }

  async assign(obj: any, keyPath: any, value: any) {
    keyPath = keyPath.split('.');
    const lastKeyIndex = keyPath.length - 1;
    for (var i = 0; i < lastKeyIndex; ++i) {
      const key = keyPath[i];
      if (!(key in obj)) {
        obj[key] = {};
      }
      obj = obj[key];
    }
    obj[keyPath[lastKeyIndex]] = value;
    return obj;
  }

  removeData(index: number) {
    if (confirm('Are you sure you want to delete this row, this can not be rolled back!')) {
      this.tableData.splice(index, 1);
    }
  }

  getType(value: any) {
    // tslint:disable-next-line:max-line-length
    const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    const isEmail = emailRegex.test(value);

    if (!value) {
      return 'text';
    } else if (!isNaN(value)) {
      return 'number';
    } else if (isEmail) {
      return 'email';
    } else {
      return 'text';
    }
  }
}
